import Layout from "../components/layout/Layout";
import Dashboard from "../components/page/Dashboard";

const DashboardPage = () => {
    return (
        <Layout>
            <Dashboard />
        </Layout>
    );
};
export default DashboardPage;
